module.exports = __webpack_public_path__ + "static/media/permisos.5aab196b.png";